import { PandaboardApiInstance } from "helpers/api";
import { LoanOfferPricingDto } from "../dtos/loanCalculator.dto";
import { LoanOfferResponse } from "../interfaces/loanOffer.interface";

export const calculateLoanOffer = (
  financialFormId: string,
  dto: LoanOfferPricingDto,
): Promise<LoanOfferResponse | null> => {
  return PandaboardApiInstance.post(
    `loan-offer/calculate/financial-form/${financialFormId}`,
    dto,
    { requireAuth: true }
  )
    .then((res) => res.data as LoanOfferResponse)
    .catch(() => null);
};

export const calculateCreditLineOffer = (
  financialFormId: string,
  dto: LoanOfferPricingDto,
): Promise<LoanOfferResponse | null> => {
  return PandaboardApiInstance.post(
    `loan-offer/calculate/financial-form/${financialFormId}/credit-line/WP`,
    dto,
    { requireAuth: true }
  )
    .then((res) => res.data as LoanOfferResponse)
    .catch(() => null);
};
